"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CONFIG_WIDGET = void 0;
exports.WidgetGenerator = WidgetGenerator;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _DonutChartGenerator = require("./DonutChart/DonutChartGenerator");
var _SunburstChartGenerator = require("./SunburstChart/SunburstChartGenerator");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DEFAULT_CLASSES = (0, _core.makeStyles)({
  widgetWrapper: {
    display: 'flex',
    minHeight: '100%'
  },
  widgetHeader: {},
  widgetDivider: {
    background: function background(theme) {
      return theme && theme.custom ? theme.custom.widgetDivider : 'transparent';
    },
    height: '6px',
    width: '180px',
    border: 'none',
    margin: '16px auto 0px auto'
  },
  paddedTitle: {
    margin: '32px 32px 0px 64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  noPaddedTitle: {
    margin: '0px 0px 0px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  widgetRoot: {},
  widgetBody: {
    margin: '0px auto',
    paddingRight: function paddingRight(theme) {
      return theme && theme.spacing ? theme.spacing.unit * 3 : 0;
    },
    paddingLeft: function paddingLeft(theme) {
      return theme && theme.spacing ? theme.spacing.unit * 3 : 0;
    }
  },
  noPadding: {
    padding: 0
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    boxShadow: 'none'
  },
  customBackGround: {
    background: function background(theme) {
      return theme && theme.palette ? theme.palette.widgetBackground.main : 'transparent';
    }
  }
});
var DEFAULT_CONFIG_WIDGET = {
  theme: null,
  classes: null,
  SunburstConfig: null,
  DonutConfig: null
};

/**
 * Exposes a function that generates a widget component based on the provided configuration
 *
 * @param {object|null} uiConfig
 * @returns {object}
 */
exports.DEFAULT_CONFIG_WIDGET = DEFAULT_CONFIG_WIDGET;
function WidgetGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIG_WIDGET;
  var theme = uiConfig.theme,
    uiClasses = uiConfig.classes,
    sbConfig = uiConfig.SunburstConfig,
    dConfig = uiConfig.DonutConfig;
  var SunburstConfig = sbConfig && typeof sbConfig === 'object' ? sbConfig : _SunburstChartGenerator.DEFAULT_CONFIG_SUNBURST;
  var _ref = (0, _SunburstChartGenerator.SunburstChartGenerator)(SunburstConfig),
    SunburstChart = _ref.SunburstChart;
  var DonutConfig = dConfig && typeof dConfig === 'object' ? dConfig : _DonutChartGenerator.DEFAULT_CONFIG_DONUT;
  var _ref2 = (0, _DonutChartGenerator.DonutChartGenerator)(DonutConfig),
    DonutChart = _ref2.DonutChart;
  var classes = uiClasses && typeof uiClasses === 'object' ? uiClasses : DEFAULT_CLASSES(theme);
  return {
    Widget: function Widget(props) {
      var _ref5;
      var title = props.title,
        header = props.header,
        noBodyPadding = props.noBodyPadding,
        bodyClass = props.bodyClass,
        customBackGround = props.customBackGround,
        bottomDivider = props.bottomDivider,
        noPaddedTitle = props.noPaddedTitle,
        chartType = props.chartType,
        sliceTitle = props.sliceTitle,
        data = props.data,
        chartTitleLocation = props.chartTitleLocation,
        chartTitleAlignment = props.chartTitleAlignment,
        children = props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.widgetWrapper
      }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
        className: (0, _classnames.default)(classes.paper, _defineProperty({}, classes.customBackGround, customBackGround)),
        classes: {
          root: classes.widgetRoot
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: title,
        className: (0, _classnames.default)(classes.widgetHeader, classes.paddedTitle, _defineProperty({}, classes.noPaddedTitle, noPaddedTitle))
      }, header || title), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.widgetBody, (_ref5 = {}, _defineProperty(_ref5, classes.noPadding, noBodyPadding), _defineProperty(_ref5, bodyClass, bodyClass), _ref5))
      }, chartType === 'donut' && /*#__PURE__*/_react.default.createElement(DonutChart, {
        data: data,
        sliceTitle: sliceTitle || 'Cases',
        width: 185,
        height: 210,
        innerRadius: 45,
        outerRadius: 80,
        cx: 90,
        cy: 98,
        titleLocation: chartTitleLocation || 'bottom',
        titleAlignment: chartTitleAlignment || 'center'
      }), chartType === 'sunburst' && /*#__PURE__*/_react.default.createElement(SunburstChart, {
        data: data,
        sliceTitle: sliceTitle || 'Cases',
        width: 250,
        height: 173,
        padAngle: 0,
        titleLocation: chartTitleLocation || 'bottom',
        titleAlignment: chartTitleAlignment || 'center'
      }), !chartType && children), bottomDivider && /*#__PURE__*/_react.default.createElement("hr", {
        className: classes.widgetDivider
      })));
    }
  };
}
var _default = WidgetGenerator;
exports.default = _default;